import { fromJS } from 'immutable';
import { markAsSideEffect, markAsSync } from '../useController';
import { removeFieldsForPayload } from './NoteInput/NoteInput.helpers';

export function createNote({ htmlText, taggedParties }) {
  const { jobId, taskId } = this.info();
  const payload = [{ htmlText, taggedParties: removeFieldsForPayload(taggedParties) }];

  this.controller.dispatch([state => state.set('isUploading', true)]);
  return this.notesService
    .createTaskNotes(payload, { params: { jobId, taskId } })
    .then(result => state => {
      this.addAlert('Note successfully added to this Task.');
      const noteId = result[0]?._id;
      const notes = state.get('notes');
      if (!notes.find(n => n.get('_id') === noteId))
        return state.update('notes', notes => notes.concat(fromJS(result)));
      return state;
    })
    .catch(err => {
      this.addAlert('There was a problem adding a note to this Task. Please try again.', 'danger');
      throw err;
    })
    .finally(() => {
      this.controller.dispatch([state => state.set('isUploading', false)]);
    });
}

export function readNotes() {
  const { jobId, taskId } = this.info();

  return this.notesService
    .getTaskNotes({}, { params: { jobId, taskId } })
    .then(fromJS)
    .then(notes => state => state.set('notes', notes));
}

markAsSideEffect(removeNote);
export function removeNote(note) {
  const { jobId, taskId } = this.info();
  const noteId = note.get('_id');
  const notes = this.state.get('notes');
  const index = notes.indexOf(note);

  this.controller.dispatch([state => state.setIn(['overlay', 'show'], false)]);

  this.notesService
    .deleteTaskNote({}, { params: { jobId, taskId, noteId } })
    .then(() => {
      this.addAlert('Note successfully removed from this Task.');
      this.controller.dispatch([state => state.set('notes', notes.remove(index))]);
    })
    .catch(err => {
      this.controller.dispatch([state => state.set('notes', notes)]);
      this.addAlert('There was a problem removing this note from the Task. Please try again.', 'danger');
      throw err;
    });
}

markAsSync(setShowAll);
export function setShowAll(state, showAll) {
  return state.set('showAll', showAll);
}

markAsSync(showOverlay);
export function showOverlay(state, show) {
  return state.setIn(['overlay', 'show'], show);
}

markAsSync(showRemovePopover);
export function showRemovePopover(state, note, target) {
  const clickedElement = target.closest('.btn');
  return state.update('overlay', overlay =>
    overlay
      .set('show', clickedElement === overlay.get('target') ? !overlay.get('show') : true)
      .set('target', clickedElement)
      .set('note', note)
  );
}

markAsSideEffect(handleRealTime);
export function handleRealTime({ action, noteId, note }) {
  this.controller.dispatch([
    state =>
      state.update('notes', notes => {
        if (action === 'create-note') {
          // to prevent duplicated notes, RT event will be received even if
          // the note was created by current user.
          if (!notes.find(n => n.get('_id') === noteId)) return notes.push(fromJS(note));
        } else if (action === 'delete-note') {
          const index = notes.findIndex(n => n.get('_id') === noteId);
          if (index >= 0) return notes.delete(index);
        }

        return notes;
      }),
  ]);
}
